export default __webpack_public_path__ + "static/media/twitter.ad5c01b1.svg";